import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

/** Absolute from site root so icons resolve on deep routes (e.g. /apps/meet/room/:id). */
const iconUrl = (fileName: string) => `/assets/icons/${fileName}.svg`;

export function registerRadiusSvgIcons(
    registry: MatIconRegistry,
    sanitizer: DomSanitizer,
    iconNames: readonly string[],
): void {
    iconNames.forEach((name) => {
        registry.addSvgIcon(
            name,
            sanitizer.bypassSecurityTrustResourceUrl(iconUrl(name)),
        );
    });
}

export function registerMeetSvgIcons(
    registry: MatIconRegistry,
    sanitizer: DomSanitizer,
    iconNames: readonly string[],
): void {
    iconNames.forEach((name) => {
        registry.addSvgIcon(
            `meet_${name}`,
            sanitizer.bypassSecurityTrustResourceUrl(iconUrl(name)),
        );
    });
}
